module.exports = __webpack_public_path__ + "img/employee-success-import.40c5d0a4.svg";